import { render, staticRenderFns } from "./DiagramTitleBar.vue?vue&type=template&id=b25dc86a&"
import script from "./DiagramTitleBar.vue?vue&type=script&lang=js&"
export * from "./DiagramTitleBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports